import { render, staticRenderFns } from "./templateAdd.vue?vue&type=template&id=9fae02c2&scoped=true"
import script from "./templateAdd.vue?vue&type=script&lang=ts"
export * from "./templateAdd.vue?vue&type=script&lang=ts"
import style0 from "./templateAdd.vue?vue&type=style&index=0&id=9fae02c2&prod&lang=scss&scoped=true"
import style1 from "./templateAdd.vue?vue&type=style&index=1&id=9fae02c2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fae02c2",
  null
  
)

export default component.exports